(() => {
  'use strict';
  const base = window.Shopify?.routes?.root || '/';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root = document) {
    root.querySelectorAll('[data-wfd-carousel]').forEach(carousel => {
      if (carousel.dataset.carouselReady) return;
      carousel.dataset.carouselReady = '1';
      const track = carousel.querySelector('[data-wfd-track]');
      if (!track) return;
      const slides = [...track.children];
      const current = () => track.scrollWidth > track.clientWidth + 4 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 4 ? slides.length - 1 : slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left) < Math.abs(slides[best].getBoundingClientRect().left - track.getBoundingClientRect().left) ? index : best, 0);
      const update = () => {
        const index = current();
        carousel.querySelector('[data-wfd-counter]').textContent = `${index + 1} / ${slides.length}`;
        carousel.querySelector('[data-wfd-prev]').disabled = track.scrollLeft < 4;
        carousel.querySelector('[data-wfd-next]').disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      };
      const move = delta => {
        const next = slides[Math.max(0, Math.min(slides.length - 1, current() + delta))];
        track.scrollBy({ left: next.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduced ? 'instant' : 'smooth' });
      };
      carousel.querySelector('[data-wfd-prev]').addEventListener('click', () => move(-1));
      carousel.querySelector('[data-wfd-next]').addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', e => { if (['ArrowLeft', 'ArrowRight'].includes(e.key)) { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } });
      new ResizeObserver(update).observe(track);
      update();
    });
    const ordinal = n => n + (n % 100 >= 11 && n % 100 <= 13 ? 'th' : ({1:'st',2:'nd',3:'rd'}[n % 10] || 'th'));
    const date = offset => { const d = new Date(); d.setDate(d.getDate() + offset); return d.toLocaleDateString('en-US', {month:'short'}) + ' ' + ordinal(d.getDate()); };
    root.querySelectorAll('[data-wfd-order-date]').forEach(e => e.textContent = date(0));
    root.querySelectorAll('[data-wfd-delivery-date]').forEach(e => e.textContent = date(4) + ' – ' + date(16));
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  const bag = document.querySelector('#WfdBag');
  let opener, pending = false;
  const error = (message, target = bag) => { const node = target.querySelector('.wfd-bag-error,.wfd-buy-error'); if (node) { node.textContent = message; node.hidden = false; } };
  const open = () => { if (!bag.open) { opener = document.activeElement; bag.showModal(); document.documentElement.classList.add('wfd-bag-open'); } };
  const close = () => bag.close();
  bag.addEventListener('close', () => { document.documentElement.classList.remove('wfd-bag-open'); opener?.focus(); });
  bag.addEventListener('click', e => { if (e.target === bag) { const r = bag.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); } });
  async function refresh() {
    const response = await fetch(`${base}?sections=wfd-bag`, { headers: {Accept:'application/json'} });
    if (!response.ok) throw new Error('Could not refresh your bag. Please open your bag to check it before adding again.');
    const sections = await response.json();
    if (!sections['wfd-bag']) throw new Error('Please refresh the page to see your bag.');
    const doc = new DOMParser().parseFromString(sections['wfd-bag'], 'text/html');
    const content = doc.querySelector('[data-wfd-bag-content]');
    if (!content) throw new Error('Please refresh the page to see your bag.');
    document.querySelectorAll('[data-wfd-bag-content]').forEach(e => e.replaceWith(content.cloneNode(true)));
    document.querySelectorAll('[data-wfd-cart-count]').forEach(e => e.textContent = content.dataset.count);
  }
  async function request(path, body) {
    const response = await fetch(base + path, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please check your bag and try again.');
    return data;
  }
  document.addEventListener('click', async e => {
    const trigger = e.target.closest('[data-wfd-open-bag]');
    if (trigger) { e.preventDefault(); open(); try { await refresh(); } catch (err) { error(err.message); } return; }
    if (e.target.closest('[data-wfd-close-bag]')) { close(); return; }
    const remove = e.target.closest('[data-wfd-remove]');
    if (!remove || pending) return;
    pending = true; remove.disabled = true;
    try { await request('cart/change.js', {id:remove.dataset.wfdRemove,quantity:0}); await refresh(); }
    catch (err) { error(err.message, remove.closest('.wfd-bag-page') || bag); remove.disabled = false; }
    finally { pending = false; }
  });
  // Run after each form's own selection handler has finalized quantity and plan.
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-wfd-simple],[data-wfd-buy],[data-wfd-bag-form]');
    if (!form || e.defaultPrevented) return;
    e.preventDefault();
    if (pending) return;
    const data = new FormData(form), items = [];
    for (const [key,value] of data) {
      const field = key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/);
      const property = key.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
      if (field) { const index = Number(field[1]); items[index] ||= {}; items[index][field[2]] = Number(value); }
      if (property) { const index = Number(property[1]); items[index] ||= {}; items[index].properties ||= {}; items[index].properties[property[2]] = value; }
    }
    const lines = items.filter(item => item?.id);
    if (!lines.length) return;
    pending = true;
    const buttons = document.querySelectorAll(`button[form="${form.id}"],#${CSS.escape(form.id)} button[type="submit"]`);
    buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy','true'); });
    let added = false;
    try {
      await request('cart/add.js', {items:lines}); added = true;
      if (String(data.get('return_to')).includes('/discount/DUOWELCOME')) {
        await request('cart/update.js', {discount:'DUOWELCOME'});
      }
      await refresh(); open();
    } catch (err) {
      if (added) { open(); try { await refresh(); } catch (_) {} error('Your items were added. Please check the total in your bag before continuing.'); }
      else { error(err.message, form); }
    } finally { pending = false; buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); }); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelector('.wfd-nav-menu')?.removeAttribute('open'); });
})();
